export default __webpack_public_path__ + "static/1_5-b2bfc5212a4a806e8bd965d4f46dccc4.png";